export const usersReducer = (state = { users: [], allusers: [] }, action) => {
  switch (action.type) {
    case "GET_LISTS_USERS":
      return {
        ...state,
        alluser: action.payload
      };
    case "ADD_USERS":
      return {
        ...state,
        users: [...state.users, action.payload],
      };
    case "UPDATE_USERS":
      return {
        ...state,
    users: state.users.map(o =>
      o.id === action.payload.id ? action.payload : o
    )
      };
    case "DELETE_USERS":
      return {
        ...state,
        users: [...state.users, action.users],
      };
    default:
      return state;
  }
};

const initialState = {
  isAdmin: false,
};

export const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_IS_ADMIN":
      localStorage.setItem("isAdmin", JSON.stringify(action.payload));
      return { ...state, isAdmin: action.payload };
    default:
      return state;
  }
};

